import { observer } from 'mobx-react-lite';
import React from 'react';

import cn from './style.module.sass';

const ContentLayout: React.FC = observer(({ children }) => (
	<div className={cn.wrapper}>
		<div className={cn.inner}>{children}</div>
	</div>
));

export const ContentLayoutWithTitle: React.FC<{ title: string }> = observer(({ children, title }) => (
	<div className={cn.wrapper}>
		<div className={cn.inner}>
			{title && <div className={cn.title}>{title}</div>}
			<div className={cn.inner}>{children}</div>
		</div>
	</div>
));

export default ContentLayout;
